import React from "react";

import styled from "styled-components/macro";

import { LinkButton } from "components/Form/Button";
import { StyledCheckbox } from "components/Form/FormikControls";
import { Column, Row } from "components/Layout";
import { SmallText, Text } from "components/Text";

import { ScanLabelArchetype } from "constants/scanLabels";

const SUBTEXT_TRUNCATE_THRESHOLD = 80;

const SelectableRow = styled(Row)(
  ({ theme, isSelected }) => `
  cursor: pointer;
  padding: ${theme.space[1]}px;
  border-radius: ${theme.radii[3]}px;
  background-color: ${isSelected ? theme.colors.primaryHighlight : "transparent"};
`,
);

const TruncatedSubtext = styled(SmallText)(
  ({ expanded }) => `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${expanded ? "" : "-webkit-line-clamp: 2;"}
`,
);

export interface ScanLabelOptionData {
  name: string;
  archetype: ScanLabelArchetype;
  subtext?: string;
}

interface ScanLabelOptionRowProps {
  option: ScanLabelOptionData;
  isSelected: boolean;
  isExpanded: boolean;
  onToggleSelect: (name: string) => void;
  onToggleExpand: (name: string) => void;
}

export const ScanLabelOptionRow: React.FC<ScanLabelOptionRowProps> = ({
  option,
  isSelected,
  isExpanded,
  onToggleSelect,
  onToggleExpand,
}) => {
  const isLongSubtext =
    (option.subtext?.length || 0) > SUBTEXT_TRUNCATE_THRESHOLD;

  return (
    <SelectableRow
      alignCenter
      isSelected={isSelected}
      onClick={() => onToggleSelect(option.name)}
    >
      <StyledCheckbox checked={isSelected} />
      <Column flexGrow>
        <Text fontSize="charlie">{option.name}</Text>
        {option.subtext && (
          <TruncatedSubtext expanded={isExpanded || !isLongSubtext}>
            {option.subtext}
            {isLongSubtext && (
              <>
                {" "}
                <LinkButton
                  type="button"
                  onClick={event => {
                    event.stopPropagation();
                    onToggleExpand(option.name);
                  }}
                >
                  {isExpanded ? "Show less" : "Show more"}
                </LinkButton>
              </>
            )}
          </TruncatedSubtext>
        )}
      </Column>
    </SelectableRow>
  );
};
